module.exports = __webpack_public_path__ + "img/img-badge-001-off@2x.8c0f502d.png";